import * as React from 'react';
import { LanguagesTitleWrapper, LanguagesWrapper } from '../ProfessionalExperienceSectionStyles';
import { language } from '../ProfessionalExperienceSectionLanguage';

export type Props = {
	languages: Array<string | { [key: string]: string[] }>;
};

export const LanguagesLayout = (props: Props) => {
	const languages = generateLanguages(props.languages.sort());
	const render = () => {
		const returnValue =
			props.languages.length === 0 ? null : (
				<LanguagesWrapper>
					<LanguagesTitleWrapper>{language.languagesHeader}:</LanguagesTitleWrapper>
					{languages}
				</LanguagesWrapper>
			);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};

const generateLanguages = (tools: Array<string | { [key: string]: string[] }>): string => {
	const result = tools.map((tool) => {
		if (typeof tool === 'string') {
			return tool;
		} else {
			const [key, values] = Object.entries(tool)[0];
			const sortedValues = values.slice().sort(); // avoid mutating original array
			return `${key} (${sortedValues.join(', ')})`;
		}
	});
	return result.join(', ');
};
